import React, {Suspense} from 'react'
import { Backdrop, CircularProgress } from "@mui/material";
import MainContent from './MainContent';

const Header = React.lazy(() => import("../../components/header"));
const Footer = React.lazy(() => import("../../components/footer"));
const OnboardingDrawer = React.lazy(() => import("../Onboarding"));


const CentrePage = () => {
  const [requestDrawer, setRequestDrawer] = React.useState("");
  return (
    <>
     <OnboardingDrawer
        open={requestDrawer}
        onClose={() => setRequestDrawer(false)}
      />
        <Header />
        <Suspense
        fallback={
          <Backdrop open>
            <CircularProgress />
          </Backdrop>
        }
      >
        <MainContent setRequestDrawer={setRequestDrawer} />
        <Footer />
      </Suspense>
    </>
  )
}

export default React.memo(CentrePage)